import React, { Component } from 'react';
import { Button, Form, FormControl, FormGroup } from 'react-bootstrap';
import Api from '../../api/api';
import Toolbar from '../../components/Header/Toolbar/Toolbar';
import '../../components/Login/Login.css';
import { storeUserPermissions, userRolesEnum } from '../../utils/RolesBasedUsers';

class LoginContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: '',
      password: '',
      encodedLogin: '',
      loginSuccess: false,
      error: null,
      isLoading: false,
      authToken: localStorage.getItem('authToken'),
      httpOther: localStorage.getItem('httpOther'),
      // loginMenuItem: "Login"
    };
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.updateNav = this.updateNav.bind(this);
  }

  dismissError(event) {
    this.setState({ error: null });
  }

  setAuthorisationToken(token) {
    if (token != null) {
      const checkForJson = 'access_token';
      if (token.includes(checkForJson)) {
        const tokenJson = JSON.parse(token);
        localStorage.setItem('authToken', `Bearer ${tokenJson.access_token}`);
      } else {
        localStorage.setItem('authToken', token);
      }
    }
    localStorage.setItem('httpOther', '');
  }

  handleClick = async event => {
    event.preventDefault();

    if (!this.state.userName) {
      return this.setState({ error: '  Username is required' });
    }

    if (!this.state.password) {
      return this.setState({ error: '  Password is required' });
    }
    try {
      const res = await Api.login(this.state.userName, this.state.password);
      this.setAuthorisationToken(res);

      let pathname = '/';
      const permissions = await Api.getUseRoles();

      storeUserPermissions(permissions);

      this.updateNav();
      this.props.history.push({
        pathname: pathname,
        state: { authToken: res },
      });
    } catch (error) {
      localStorage.setItem('httpOther', error.message);
      this.setState({ error: `${error.message}` });
    }
  };

  updateNav() {
    try {
      const obj = document.getElementById('navLoginLogout');
      obj.innerText = 'Logout';
    } catch (e) {
      console.error(e);
    }
  }

  handleUserChange(event) {
    this.setState({
      userName: event.target.value,
    });
  }

  handlePassChange(event) {
    this.setState({
      password: event.target.value,
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-header">
          <Toolbar />
        </div>

        <div className="container-fluid text-center">
          <div className="loginWrapper">
            <div className="loginTitle">Features Portal</div>
            {this.state.httpOther && <div className="error">{this.state.httpOther}</div>}
            <Form>
              <FormGroup>
                {this.state.error && (
                  <div
                    className="alert alert-warning alert-dismissible"
                    onClick={event => this.dismissError(event)}
                  >
                    <a tabIndex="0" className="close" data-dismiss="alert" aria-label="close">
                      &times;
                    </a>
                    {this.state.error}
                  </div>
                )}
                <div className="loginLabel">Username</div>
                <FormControl
                  type="text"
                  placeholder="Enter username"
                  className="loginUsernameInput"
                  value={this.state.userName}
                  onChange={this.handleUserChange}
                />
                <div className="loginLabel">Password</div>
                <FormControl
                  type="password"
                  placeholder="Enter password"
                  className="loginPasswordInput"
                  value={this.state.password}
                  onChange={this.handlePassChange}
                />
                <Button
                  type="submit"
                  bsstyle="danger"
                  className="loginButton"
                  onClick={event => this.handleClick(event)}
                >
                  <span>Login</span>
                </Button>
              </FormGroup>
            </Form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/containers/Login/LoginContainer.js